/* global axios */
import ApiClient from './ApiClient';

class LaisWhatsappConnectionsAPI extends ApiClient {
  constructor() {
    super('lais_whatsapp_connections', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  generateQr(payload = {}) {
    return axios.post(this.url, payload);
  }

  refreshQr(id) {
    return axios.post(`${this.url}/${id}/refresh_qr`);
  }

  refreshCallGatewayQr(id) {
    return axios.put(`${this.url}/${id}/call_gateway`, { refresh: true });
  }

  updateOwner(id, userId) {
    return axios.patch(`${this.url}/${id}`, { user_id: userId });
  }

  deleteConnection(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new LaisWhatsappConnectionsAPI();
